// extracted by mini-css-extract-plugin
export default {"backStep":"BackStep_backStep__sF0Zj","backLink":"BackStep_backLink__eKYd-","goBackImg":"BackStep_goBackImg__XJDC9"};